const local = 'http://coaniquemcard.local/'
const devel = 'https://www.italgnol.cls/card/backend/'
const prod = 'https://saludosconsentido-be.coaniquem.cl'

// const url = process.env.NODE_ENV === 'development' ? local : prod
const url =  prod

export const UrlPay = `${url}payments/pay`

export const UrlCards = `${url}cards`

export const UrlCategory = `${url}categories`

export const UrlPDF = `${url}pdf`

export const UrlPDFChristmas = `${url}pdf-christmas`

export const URLLogin = `${url}login`
export const URLLogout = `${url}logout`

export const UrlChart = `${url}export/json`
export const UrlCreate = `${url}cards`
export const UrlDelete = `${url}cards`
export const UrlModify = `${url}cards`
